import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export function updateIntentState(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_INTENT_STATE,
            payload,
            path
        });
    };
}

export function deleteIntentState(path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.DELETE_INTENT_STATE,
            path
        });
    };
}

export function fetchAllIntents() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.ALL_INTENTS_LOADING,
        });
        API.fetchAllIntents({}, (error, response) => {
            log('all intents response:', response);
            if (!error) {
                dispatch({
                    type: actionTypes.ALL_INTENTS_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.ALL_INTENTS_LOAD_ERROR,
                });
            }
        });
    };
}

export function createIntent(data, closeModal, editIntent) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.INTENT_CREATING,
        });
        API.createIntent(data, (error, response) => {
            log('create intent response:', response);
            if (!error && response && response.intent) {
                dispatch({
                    type: actionTypes.INTENT_CREATED,
                    payload: response
                });
                showMessage('success', response && response.message ? response.message : 'intent successfully created.');
                if (closeModal) closeModal();
                if (editIntent) setTimeout(() => editIntent(response.intent), 500);
            } else {
                dispatch({
                    type: actionTypes.INTENT_CREATION_FAILED,
                    payload: response
                });
            }
        });
    };
}

export function deleteIntent(data) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "intent deleting"
        });
        API.deleteIntent(data, (error, response) => {
            log('delete intent response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response) {
                dispatch({
                    type: actionTypes.INTENT_DELETED,
                    payload: response
                });
                showMessage('success', response && response.message ? response.message : 'intent successfully deleted.');
            }
        });
    };
}

export function getIntentData(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.INTENT_DATA_LOADING,
        });
        API.getIntentData(data, (error, response) => {
            log('intent data response:', response);
            if (!error) {
                dispatch({
                    type: actionTypes.INTENT_DATA_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.INTENT_DATA_ERROR,
                });
            }
        });
    };
}

export function addNewUtterance(data, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "New Utterance adding"
        });

        API.addNewUtterance(data, (error, response) => {
            log('add utterance response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error) {
                dispatch({
                    type: actionTypes.NEW_UTTERANCE_ADDED,
                    payload: response,
                });
                if (callback) callback();
            }
        });
    };
}

export function deleteUtterance(data) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "Removing Utterance"
        });

        API.deleteUtterance(data, (error, response) => {
            log('delete utterance response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error) {
                dispatch({
                    type: actionTypes.UTTERANCE_DELETED,
                    payload: response,
                });
            }
        });
    };
}

export function updateUtterance(data, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "Updating Utterance"
        });
        API.updateUtterance(data, (error, response) => {
            log('update utterance response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error) {
                dispatch({
                    type: actionTypes.UTTERANCE_UPDATED,
                    payload: response,
                });
                if (callback) callback();
            }
        });
    };
}

export function updateIntent(data, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "Updating Intent"
        });
        API.updateIntent(data, (error, response) => {
            log('update intent response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response) {
                dispatch({
                    type: actionTypes.INTENT_UPDATED,
                    payload: response
                });
                showMessage('success', response && response.message ? response.message : 'intent successfully updated.');
                if (callback) callback();
            }
        });
    };
}

export function clearActiveIntent() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.CLEAR_ACTIVE_INTENT,
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/intent_details/actions.js